import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';

export const getRedemptionById = createAsyncThunk(
  `spotAproveRedemption/loadDataSpot`,
  async ({ redemptionId }, { getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const { data } = await redemptionsApiClient.get(
      `/redemption/${redemptionId}`,
      {
        headers,
      }
    );

    return {...data,  currentParticipantId: user.profile['custom:participant_id']};
  }
);
export const loadRedemptionCategories = createAsyncThunk(
  'spotNewSolicitationSlice/loadCategorias',
  async (_, { getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const { data } = await redemptionsApiClient.get(`/Category`, {
      headers,
    });
    return data;
  }
);
export const loadRedemptionSubCategories = createAsyncThunk(
  'spotNewSolicitationSlice/loadSubCategorias',
  async ({ id }, { getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const { data } = await redemptionsApiClient.get(
      `/Category/SubCategory?Categoryid=${id}`,
      {
        headers,
      }
    );
    return data;
  }
);

const initialState = {
  dataSpot: {},
  quote: '',
  loadingSpot: false,
  errorSpotEdit: false,
  loadingCategories: false,
  loadingSubCategories: false,
  dataCategories: [],
  dataSubCategories: [],
  errorCategories: false,
  errorSubCategories: false,
  isAccessParticipantToEditRedemption: false,
};

const spotEditRedemption = createSlice({
  name: 'spotEditRedemption',
  initialState,
  reducers: {
    resetDataSpot: (state) => {
      state.dataSpot = {};
      state.quote = '';
      state.loadingSpot = false;
      state.errorSpotEdit = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRedemptionById.pending, (state) => {
      state.loadingSpot = true;
      state.errorSpotEdit = false;
    });
    builder.addCase(getRedemptionById.fulfilled, (state, action) => {
      state.loadingSpot = false;
      state.dataSpot = action.payload;
      state.errorSpotEdit = false;

      const {currentParticipantId, participantId, sendToOperation} = action.payload;
      state.isAccessParticipantToEditRedemption = currentParticipantId == String(participantId) && sendToOperation;

      if (action.payload.files !== null) {
        const file = action.payload?.files?.filter(
          (files) => files.type === 1 && files
        );

        const quote = file[0]?.url;

        state.quote = quote;
      }
    });
    builder.addCase(getRedemptionById.rejected, (state) => {
      state.loadingSpot = false;
      state.errorSpotEdit = true;
    });
    builder.addCase(loadRedemptionCategories.pending, (state) => {
      state.loadingCategories = true;
      state.errorCategories = false;
    });
    builder.addCase(loadRedemptionCategories.fulfilled, (state, action) => {
      state.loadingCategories = false;
      state.dataCategories = action.payload;
      state.errorCategories = false;
    });
    builder.addCase(loadRedemptionCategories.rejected, (state) => {
      state.loadingCategories = false;
      state.errorCategories = true;
    });
    builder.addCase(loadRedemptionSubCategories.pending, (state) => {
      state.loadingSubCategories = true;
      state.errorSubCategories = false;
    });
    builder.addCase(loadRedemptionSubCategories.fulfilled, (state, action) => {
      state.loadingSubCategories = false;
      state.dataSubCategories = action.payload;
      state.errorSubCategories = false;
    });
    builder.addCase(loadRedemptionSubCategories.rejected, (state) => {
      state.loadingSubCategories = false;
      state.errorSubCategories = true;
    });
  },
});
export const { resetDataSpot } = spotEditRedemption.actions;

export default spotEditRedemption.reducer;
